(function () {
  const gridSelector =
    '.ecom-collection__product-main.ecom-collection_product_template_collection .ecom-collection__product--wrapper-items';
  const itemClassName = 'ecom-collection__product-item';
  const flagSelector = '.roi-editorial-flag';
  const productCardSelector = '.ecom-collection__product-item';
  const titleSelector = '.ecom-collection__product-item-information-title';
  const soldOutBadgeSelector = '.ecom-collection__product-badge--sold-out';
  const soldOutLabelClass = 'roi-collection-out-of-stock';
  const requestFrame =
    window.requestAnimationFrame ||
    function (callback) {
      return window.setTimeout(callback, 16);
    };
  let isScheduled = false;

  function getColumnCount(grid) {
    const computedColumns = window.getComputedStyle(grid).gridTemplateColumns;

    if (computedColumns && computedColumns !== 'none') {
      return computedColumns
        .split(' ')
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean).length;
    }

    const fallbackColumns = parseInt(grid.dataset.gridColumn || '', 10);
    return Number.isFinite(fallbackColumns) ? fallbackColumns : 0;
  }

  function applyEditorialLayout() {
    document.querySelectorAll(gridSelector).forEach(function (grid) {
      let hasFeaturedItem = false;

      Array.from(grid.children).forEach(function (child) {
        if (!(child instanceof HTMLElement) || !child.classList.contains(itemClassName)) {
          return;
        }

        if (cardIsSoldOut(child)) {
          child.dataset.roiSoldOut = 'true';
          delete child.dataset.roiEditorialFeatured;
          return;
        }

        delete child.dataset.roiSoldOut;

        if (child.querySelector(flagSelector)) {
          child.dataset.roiEditorialFeatured = 'true';
          hasFeaturedItem = true;
          return;
        }

        delete child.dataset.roiEditorialFeatured;
      });

      if (hasFeaturedItem) {
        grid.dataset.roiEditorialGrid = 'true';
        grid.dataset.roiEditorialColumns = String(getColumnCount(grid));
        return;
      }

      delete grid.dataset.roiEditorialGrid;
      delete grid.dataset.roiEditorialColumns;
    });
  }

  function isVisible(element) {
    if (!(element instanceof HTMLElement)) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0'
    );
  }

  function cardIsSoldOut(card) {
    const soldOutBadge = card.querySelector(soldOutBadgeSelector);
    if (isVisible(soldOutBadge)) {
      return true;
    }

    const addToCartButton = card.querySelector(
      '.ecom-collection__product-submit, .ecom-product-single__add-to-cart--submit'
    );

    if (
      addToCartButton &&
      /out\s*stock|unavailable/i.test(addToCartButton.textContent || '')
    ) {
      return true;
    }

    return false;
  }

  function applyCollectionSoldOutLabels() {
    document.querySelectorAll(productCardSelector).forEach(function (card) {
      if (!(card instanceof HTMLElement)) {
        return;
      }

      card.querySelectorAll('.' + soldOutLabelClass).forEach(function (label) {
        label.remove();
      });

      if (!cardIsSoldOut(card)) {
        return;
      }

      const title = card.querySelector(titleSelector);
      if (!(title instanceof HTMLElement)) {
        return;
      }

      const label = document.createElement('div');
      label.className = soldOutLabelClass;
      label.textContent = 'Waitlist';

      const anchorTitle = title.closest('h3') || title;
      anchorTitle.insertAdjacentElement('afterend', label);
    });
  }

  function bindCollectionFilterButton() {
    function openFilterModal(button) {
      if (!(button instanceof HTMLButtonElement)) {
        return;
      }

      const container = button.closest('.ecom-collection__filters-container');
      if (!(container instanceof HTMLElement)) {
        return;
      }

      const modal = container.querySelector('.ecom-filter-modal');
      if (!(modal instanceof HTMLElement)) {
        button.click();
        return;
      }

      const coreBlock = modal.closest('div.ecom-core.core__block');
      const coreColumn = modal.closest('div.ecom-column.ecom-core');

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      modal.style.display = 'block';

      if (coreBlock instanceof HTMLElement) {
        coreBlock.style.zIndex = '99';
      }

      if (coreColumn instanceof HTMLElement) {
        coreColumn.style.zIndex = '99';
      }

      document.body.classList.add('ecom-filter-opened');
    }

    document
      .querySelectorAll(
        '.ecom-collection__filters-wrapper[data-page="collection"] .ecom-collection__filters-container'
      )
      .forEach(function (container) {
        if (!(container instanceof HTMLElement)) {
          return;
        }

        const button = container.querySelector('#button_menu_block.ecom-filter-btn-toggle');
        if (!(button instanceof HTMLButtonElement)) {
          return;
        }

        button.style.pointerEvents = 'auto';

        if (button.dataset.roiFilterButtonBound === 'true') {
          return;
        }

        button.dataset.roiFilterButtonBound = 'true';

        function handleOpen(event) {
          event.preventDefault();
          event.stopPropagation();
          openFilterModal(button);
        }

        button.addEventListener('click', handleOpen, true);

        container.addEventListener(
          'click',
          function (event) {
            const target = event.target;

            if (!(target instanceof Element)) {
              return;
            }

            if (target.closest('.ecom-filter-modal .ecom-modal-content')) {
              return;
            }

            if (target.closest('.ecom-filter-modal-close')) {
              return;
            }

            if (target.closest('#button_menu_block') || target === container) {
              handleOpen(event);
            }
          },
          true
        );

        button
          .querySelectorAll('.ecom-filter-collapse-icon, .ecom-filter-collapse-icon *, span:last-child')
          .forEach(function (target) {
            target.addEventListener('click', handleOpen, true);
          });
      });
  }

  function scheduleApplyEditorialLayout() {
    if (isScheduled) {
      return;
    }

    isScheduled = true;
    requestFrame(function () {
      isScheduled = false;
      applyEditorialLayout();
      applyCollectionSoldOutLabels();
      bindCollectionFilterButton();
    });
  }

  function shouldReapply(mutations) {
    return mutations.some(function (mutation) {
      if (mutation.type === 'childList') {
        return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
      }

      if (!(mutation.target instanceof Element)) {
        return false;
      }

      return mutation.target.matches(flagSelector) || Boolean(mutation.target.closest(gridSelector));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApplyEditorialLayout, { once: true });
  } else {
    scheduleApplyEditorialLayout();
  }

  window.addEventListener('load', scheduleApplyEditorialLayout);
  window.addEventListener('resize', scheduleApplyEditorialLayout);
  document.addEventListener('ecom-products-init', scheduleApplyEditorialLayout, true);
  document.addEventListener('shopify:section:load', scheduleApplyEditorialLayout);

  new MutationObserver(function (mutations) {
    if (shouldReapply(mutations)) {
      scheduleApplyEditorialLayout();
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden']
  });
})();
